export default __webpack_public_path__ + "static/media/fifa-20.d0c727bd.png";